const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <path
            d="M15 28.84a2.25 2.25 0 00.71 1.661l20.094 19.5c.456.454 1.005.68 1.647.68a2.301 2.301 0 002.014-1.12 2.19 2.19 0 00.317-1.17c0-.62-.228-1.166-.684-1.635L20.65 28.84l18.447-17.915c.456-.47.684-1.015.684-1.635a2.19 2.19 0 00-.317-1.17A2.301 2.301 0 0037.451 7c-.642 0-1.191.218-1.647.654L15.71 27.18c-.237.235-.414.49-.533.767a2.25 2.25 0 00-.177.893z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>
`;
export {
  l as default
};
//# sourceMappingURL=arrow-left.es.DyQh8wom.js.map
